import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { isSameDay, isAfter, isSunday, isMonday, isTuesday, isWednesday, isFuture, formatDistanceToNow, isTomorrow, isSameWeek, format, add } from "date-fns";
import tippy from "tippy.js";

export default class extends Controller {
  static targets = ["input", "desc"]
  static values = {
    enable: Array,
    blackout: Array
  }

  connect() {
    
    const blackoutDates = this.blackoutValue.map(date => new Date(date));

    flatpickr(this.inputTarget, {
      altInput: true,
      altFormat: "j F Y",
      dateFormat: "Y-m-d",
      minDate: "today",
      enable: this.enableValue,
      maxDate: new Date().fp_incr(7*6),
      onChange: (selectedDates, dateStr, instance) => {
        console.log(selectedDates, dateStr, instance);
        if(selectedDates.length > 0) {
          if(isTomorrow(selectedDates[0])) {
            this.descTarget.innerHTML = "↑ That's <strong>tomorrow</strong>";
          } else if (isSameWeek(selectedDates[0], new Date())) {
            this.descTarget.innerHTML = "↑ That's this <strong>" + format(selectedDates[0], "EEEE") + "</strong>";
          } else if (isSameWeek(selectedDates[0], add(new Date(), { weeks: 1 }))) {
            this.descTarget.innerHTML = "↑ That's <strong>next week</strong>";
          } else {
            const date = add(selectedDates[0], { days: 1 });
            this.descTarget.innerHTML = "↑ That's <strong>" + formatDistanceToNow(date, { addSuffix: true }) + "</strong>";
          }
        } else {
          this.descTarget.textContent = "";
        }
      },
      onDayCreate: (dObj, dStr, fp, dayElem) => {

        if(isSameDay(dayElem.dateObj, new Date())) {
          dayElem.dataset.tippyContent = "Please call if you need to order today";
          tippy(dayElem, {
            zIndex: 99999
          })
          return;
        }

        if(blackoutDates.some(date => isSameDay(date, dayElem.dateObj))) {
          dayElem.classList.add("blackout");
          dayElem.dataset.tippyContent = "Sorry we are closed on this date";
          tippy(dayElem, {
            zIndex: 99999
          })
          return;
        }
        if(isAfter(dayElem.dateObj, new Date().fp_incr(7*6))) {
          dayElem.classList.add("future");
          dayElem.dataset.tippyContent = "You can order up to 6 weeks in advance";
          tippy(dayElem, {
            zIndex: 99999
          })
          return;
        }
        if(isFuture(dayElem.dateObj) && (isSunday(dayElem.dateObj) || isMonday(dayElem.dateObj) || isTuesday(dayElem.dateObj) || isWednesday(dayElem.dateObj)) && dayElem.classList.contains("flatpickr-disabled")) {
          dayElem.dataset.tippyContent = "We're usually open Thu, Fri & Sat";
          tippy(dayElem, {
            zIndex: 99999
          })
          return;
        }

        if(isFuture(dayElem.dateObj) && dayElem.classList.contains("flatpickr-disabled")) {
          dayElem.dataset.tippyContent = "Please call us to order";
          tippy(dayElem, {
            zIndex: 99999
          })
          return;
        }
      },

    })

    
  }
}